<div class="gridFilter fxf-auto-fill-r fxl-row">
  <form (ngSubmit)="textFilterApplied()" [formGroup]="formGroup" class="whole-width">
    <mat-form-field [color]="accentThemeFlag ? 'accent' : 'primary'" class="whole-width">
      <mat-label>{{ matLabel }}</mat-label>
      <input
        #_textFilterInput
        (keydown)="textFilterChangedHandler()"
        [maxlength]="maxlength"
        [ngClass]="textFilterAppliedFlag ? 'active-filter' : ''"
        autocomplete="off"
        data-testid="text-filter-input"
        formControlName="textFilter"
        matInput
      />
      <button
        (click)="textFilterApplied()"
        [attr.aria-label]="'Filtrer'"
        class="icon-button-fix-alignment xsmall-icon-button"
        mat-icon-button
        matSuffix
        matTooltip="Filtrer"
      >
        <mat-icon>search</mat-icon>
      </button>
      <button
        (click)="clear()"
        [attr.aria-label]="'Effacer le filtre de recherche'"
        class="icon-button-fix-alignment xsmall-icon-button"
        mat-icon-button
        matSuffix
        matTooltip="Effacer le filtre de recherche"
      >
        <mat-icon>clear</mat-icon>
      </button>
    </mat-form-field>
  </form>
</div>
